var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipSolid = function SvgTipSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm.988-13.75a2.75 2.75 0 0 1 2.462 1.375.75.75 0 0 1-1.3.75A1.25 1.25 0 0 0 13 8.75h-.994a.683.683 0 0 1-.012 0H11a1.25 1.25 0 0 0 0 2.5h2a2.75 2.75 0 1 1 0 5.5h-.25V18a.75.75 0 0 1-1.5 0v-1.25h-.238a2.75 2.75 0 0 1-2.462-1.376.75.75 0 1 1 1.3-.749 1.25 1.25 0 0 0 1.15.625h2a1.25 1.25 0 0 0 0-2.5h-2a2.75 2.75 0 0 1 0-5.5h.25V6a.75.75 0 0 1 1.5 0v1.25h.238Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTipSolid;